import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import party from 'party-js';
import { objectivesActions } from 'state/ducks/objectives';
import { getKeyResultCompletionPct } from 'config/helpers';

import Form from 'Components/Library/Forms';
import LinearIndicator from 'Components/Library/Forms/Elements/LinearIndicator';

const schema = {
  type: 'object',
  properties: {
    status: { type: 'number' },
  },
  required: ['status'],
  additionalProperties: true,
};

const createReduxAction = params => {
  const { confidence, ...rest } = params;
  const actionCreator = objectivesActions.updateKeyresult;

  return actionCreator(rest);
};

function KrStatusForm(props) {
  const { children, keyresultData } = props;

  const ref = useRef(null);
  const theme = useTheme();
  const startParty = (dispatchedParams, formRef) => {
    const { baseline, target } = keyresultData;
    const { status } = dispatchedParams;
    const nextValue = getKeyResultCompletionPct({ status, baseline, target });
    // Launch confetti animation if submitting will take the keyresult to 100%:
    if (nextValue >= 100 && ref.current) {
      party.confetti(formRef.current, {
        count: 120,
        size: 0.5,
        spread: party.variation.skew(90, 0.7),
        angle: 180,
        velocity: party.variation.skew(500, 0.7),
        color: [
          party.Color.fromHex(theme.palette.secondary.main),
          party.Color.fromHex(theme.palette.secondary.light),
          party.Color.fromHex(theme.palette.secondary.light),
          party.Color.fromHex(theme.palette.secondary.dark),
          party.Color.fromHex(theme.palette.confidence.red),
          party.Color.fromHex(theme.palette.warning.main),
          party.Color.fromHex(theme.palette.error.main),
        ],
      });
    }
  };

  return (
    <Form
      name="kr-status-update"
      schema={schema}
      initialValues={{ status: keyresultData.status }}
      onSubmitDispatched={dispatchedParams => startParty(dispatchedParams, ref)}
      forwardRef={ref}
      debouncedAutoSubmit={950}
      submitActionCreator={createReduxAction}
      stateSlice="main.objectives"
      additionalProperties={{ keyresultID: keyresultData.keyresultID }}
      preventSaveIncomplete
    >
      <LinearIndicator positioning="absolute" />
      {children}
    </Form>
  );
}

KrStatusForm.propTypes = {
  keyresultData: PropTypes.object,
};

export default KrStatusForm;
